/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

 import React, { useEffect, useState } from "react"
 import s from "../css/products.module.css"
 import { urls } from "../../../../../constants"
 import EventPriceItem from './event-price-item'

 const EventItem = ({ event, dataImages, onPrezzoClick }) => {
 
   const [selectedEventImage, setSelectedEventImage] = useState(null)
 
   useEffect(() => {
 
     let img = dataImages.allFile.edges.find(e => e.node.base.indexOf(`${event.image}.`) === 0);
     setSelectedEventImage(img ? img : null);
 
   }, [])
 
   return (
     <>
       <div className={`relative flex flex-col container-grid ${s.container}`} style={{ marginTop: '70px', columnGap:0, padding:0 }}>
         <div className="col-span-4 desktop:col-span-6">
             {selectedEventImage && <img src={selectedEventImage.node.publicURL} style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
         </div>
         <div className={`flex flex-col col-span-4 desktop:col-start-7 desktop:col-end-13`} style={{ padding: '50px' }}>
           <div className="flex-grow">
             <div className="text-5 leading-8 desktop:text-24 desktop:leading-21 font-bd text-black">{event.title}</div>
             <div className="text-7 leading-6 mt-p18 desktop:text-6 desktop:leading-6_1 font-rg text-black desktop:mt-p30" dangerouslySetInnerHTML={{__html: event.description}}></div>
           </div>
           <div className={`mt-p18 desktop:mt-p25 flex flex-row`} style={{ height: '81px' }}>
             <EventPriceItem title={event.price_title} onClick={() => { onPrezzoClick(true, 'event', event) } } />
           </div>          
           <div className="mt-p18 desktop:mt-p25">
             <div className="text-5 leading-8 text-primary font-bd desktop:text-2" style={{marginTop:'4px'}}><a href={urls.REGOLAMENTO}>Leggi il regolamento</a></div>
           </div>
         </div>
       </div>
     </>
   );
 }
 
 
 export default EventItem
 